<template>
  <section>
    <div class="row">
      <div v-if="user" class="col-lg-12 col-md-12">
        <div class="page-header">
          <p class="page-title">{{ $t('profile.titles.profile') }}</p>
        </div>
        <b-form
          class="input-password-form-black input-password-form custom-input-form preview"
          aria-live="assertive"
        >
          <b-form-group
            class="my-4"
            :label="$t('form.name.label')"
            label-for="user-profile-firstName"
            label-class="text-muted mb-2"
          >
            <b-input-group>
              <b-form-input
                id="user-profile-firstName"
                v-model="form.firstName"
                name="user-profile-firstName"
                class="custom-form-input custom-form-input-class text-muted"
                :state="validateState('firstName')"
                aria-describedby="input-firstName-feedback"
                :placeholder="$t('form.name.label')"
              ></b-form-input>
              <b-form-invalid-feedback id="input-firstName-feedback">
                {{ $t('message.error.requiredField') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group
            class="my-4"
            :label="$t('form.surname.label')"
            label-for="user-profile-secondName"
            label-class="text-muted mb-2"
          >
            <b-input-group>
              <b-form-input
                id="user-profile-secondName"
                v-model="form.secondName"
                name="user-profile-secondName"
                class="custom-form-input custom-form-input-class text-muted"
                :placeholder="$t('form.surname.label')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
          <b-form-group
            class="my-4"
            :label="$t('form.email.label')"
            label-for="user-profile-email"
            label-class="text-muted mb-2"
          >
            <b-input-group>
              <b-form-input
                id="user-profile-email"
                v-model="form.login"
                class="custom-form-input custom-form-input-class text-muted"
                name="user-profile-email"
                disabled
              ></b-form-input>
            </b-input-group>
          </b-form-group>
          <b-form-group
            class="my-4"
            :label="$t('form.phone.label')"
            label-for="user-profile-phone"
            label-class="text-muted mb-2"
          >
            <b-input-group>
              <b-form-input
                id="user-profile-phone"
                v-model="form.phone"
                class="custom-form-input custom-form-input-class text-muted"
                name="user-profile-phone"
              ></b-form-input>
              <b-form-invalid-feedback id="user-profile-phone">
                {{ $t('message.error.requiredField') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-form>
      </div>
    </div>
    <div class="d-flex justify-content-between my-4 pt-3 pb-4">
      <b-btn variant="transparent" size="lg" class="btn-icon-text" @click="cancel">
        {{ $t('button.cancel.label') }}
      </b-btn>
      <b-btn variant="primary" size="lg" class="btn-icon-text" @click="save">
        {{ $t('button.save.label') }}
      </b-btn>
    </div>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

export default {
  name: 'SmartOeeProfileForms',
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        id: '',
        firstName: '',
        secondName: '',
        email: '',
        phone: '',
        _isValidPhone: true,
        _invalidSave: false,
      },
    };
  },
  validations: {
    form: {
      _isValidPhone: {
        required,
        valid: (value) => value === true,
      },
      firstName: {
        required,
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    save() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.form._invalidSave = true;
        return;
      }

      this.$emit('save', this.form);
    },
    cancel() {
      this.$emit('cancel');
      this.resetForm();
    },
    validatePhone(is) {
      this.form._isValidPhone = is;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    init() {
      this.form = {
        id: this.user.id,
        firstName: this.user.firstName,
        secondName: this.user.secondName,
        login: this.user.login,
        phone: this.user.phoneBusiness,
        _isValidPhone: true,
        _invalidSave: false,
      };
    },

    resetForm() {
      this.form = {
        id: '',
        firstName: '',
        secondName: '',
        login: '',
        phone: '',
        _isValidPhone: true,
        _invalidSave: false,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
